import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Input from '../../form/Input'
import Select from '../../form/Select'
import Checkbox from '../../form/Checkbox'
import Radio from '../../form/Radio'
import TextArea from '../../form/TextArea'
import Button from '../../../UniformComponents/Button'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Typography from '../../../UniformComponents/Typography'

import './emailBuilder.scss'

@observer
class CreateUserModal extends Component {
    userLink = () => {
        const { distributeStore } = this.props
        const { store, editingUser } = distributeStore
        const { survey } = store

        const link = survey.getUserLink(editingUser, store.useLatestUI)

        return (
            <div>
                <Typography type="b">{i18n.t('s_email_user_email_link')}</Typography>
                <div
                    style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                    }}
                >
                    <Typography type="tiny">{link}</Typography>

                    <i
                        className="fal fa-copy fa-2x"
                        onClick={() => store.copyText(link, i18n.t('s_email_user_email_link'))}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
            </div>
        )
    }

    changePopulatedCH = (e) => {
        const { distributeStore } = this.props

        const { id, name } = e

        if (!distributeStore.prePopulatedResponses.has(name)) {
            distributeStore.prePopulatedResponses.set(name, [id])
        } else {
            let options = distributeStore.prePopulatedResponses.get(name)
            const index = options.indexOf(id)
            if (index === -1) {
                options.push(id)
            } else {
                // options = options.splice(index, 1)
                options.remove(id)
            }
            distributeStore.prePopulatedResponses.set(name, options)
            console.log(options)
            console.log(index, options.length)
        }
        console.log(distributeStore.prePopulatedResponses.toJS())
    }

    changePopulatedRD = (e) => {
        const { distributeStore } = this.props
        const { name, id } = e

        distributeStore.prePopulatedResponses.set(name, [id])
        console.log(distributeStore.prePopulatedResponses.get(name))
    }

    changePopulatedTX = (e) => {
        const { distributeStore } = this.props

        const { value, name } = e
        distributeStore.prePopulatedResponses.set(name, [value])
        console.log(distributeStore.prePopulatedResponses.get(name))
    }

    changePopulatedTA = (e) => {
        const { distributeStore } = this.props

        const { value, name } = e
        distributeStore.prePopulatedResponses.set(name, [value])
        console.log(distributeStore.prePopulatedResponses.get(name))
    }

    RD = (question) => {
        const { distributeStore } = this.props

        const questionResponses = distributeStore.prePopulatedResponses.has(question.value)
            ? distributeStore.prePopulatedResponses.get(question.value) : []
        this.hasPrepopulated = true

        return (
            <div style={{ marginBottom: '15px' }}>
                <Typography type="b">{question.pureLabel}</Typography>

                <div>
                    {question.qOptions.map((option) => (
                        <Radio
                            id={option.id}
                            label={option.title}
                            onBlur={(e) => this.changePopulatedRD({ id: e.value.toUpperCase(), name: question.value })}
                            checked={questionResponses.indexOf(option.id.toUpperCase()) > -1}
                        />
                    ))}
                </div>
            </div>
        )
    }

    CH = (question) => {
        const { distributeStore } = this.props

        const questionResponses = distributeStore.prePopulatedResponses.has(question.value)
            ? distributeStore.prePopulatedResponses.get(question.value) : []
        this.hasPrepopulated = true

        return (
            <div style={{ marginBottom: '15px' }}>
                <Typography type="b">
                    {question.pureLabel}
                </Typography>

                <div>
                    {question.qOptions.map((option) => (
                        <Checkbox
                            onBlur={(e) => this.changePopulatedCH({ id: e.value.toUpperCase(), name: question.value })}
                            defaultChecked={questionResponses.indexOf(option.id.toUpperCase()) > -1}
                            name={question.value}
                            label={option.title}
                        />
                    ))}
                </div>
            </div>
        )
    }

    TA = (question) => {
        const { distributeStore } = this.props

        const questionResponse = distributeStore.prePopulatedResponses.has(question.value)
            ? distributeStore.prePopulatedResponses.get(question.value)[0] : ''
        this.hasPrepopulated = true

        return (
            <div style={{ marginBottom: '15px' }}>
                <Typography>
                    {question.pureLabel}
                </Typography>

                <TextArea
                    onBlur={this.changePopulatedTA}
                    name={question.value}
                    style={{ width: '400px' }}
                    defaultValue={questionResponse}
                />
            </div>
        )
    }

    TX = (question) => {
        const { distributeStore } = this.props

        const questionResponse = distributeStore.prePopulatedResponses.has(question.value)
            ? distributeStore.prePopulatedResponses.get(question.value)[0] : ''
        this.hasPrepopulated = true

        return (
            <div style={{ marginBottom: '15px' }}>
                <Typography>
                    {question.pureLabel}
                </Typography>

                <Input
                    name={question.value}
                    defaultValue={questionResponse}
                    style={{ width: '400px' }}
                    type="text"
                    onBlur={this.changePopulatedTX}
                />
            </div>
        )
    }

    getPrePopulated = () => {
        const { distributeStore } = this.props
        const { store } = distributeStore
        const { survey } = store
        const questions = survey.pages.reduce((qArray, page) => {
            if (page.questions) {
                qArray = qArray.concat(page.questions.filter((pq) => pq.hasPrepopulatedData))
            }
            return qArray
        }, [])

        return questions.map((q) => {
            const pageQuestion = distributeStore.surveyQuestions
                .find((sq) => sq.value.toUpperCase() === q.id.toUpperCase())
            let element = null
            if (pageQuestion) {
                switch (pageQuestion.type) {
                    case 'RD':
                        element = this.RD(pageQuestion)
                        break
                    case 'CH':
                        element = this.CH(pageQuestion)
                        break
                    case 'TA':
                        element = this.TA(pageQuestion)
                        break
                    case 'TX':
                        element = this.TX(pageQuestion)
                        break
                    default:
                        element = null
                }
            }
            return element
        })
    }

    render() {
        const { distributeStore } = this.props
        const { userData, editingUser } = distributeStore
        const prePopulatedData = this.getPrePopulated()

        return (
            <Modal
                show={distributeStore.createUserModalVisible}
                onClose={distributeStore.hideCreateUserModal}
            >
                <div className="email-list-modal">
                    <h2>{i18n.t(editingUser ? 'createUserModal.editTitle' : 'createUserModal.createTitle')}</h2>

                    <h4>{i18n.t('createUserModal.subtitle')}</h4>
                </div>

                <div className="create-user-modal-inputs">
                    <Input
                        name="email"
                        label={i18n.t('email')}
                        placeholder={i18n.t('form.input.placeholder')}
                        onBlur={distributeStore.createUserOnChange}
                        defaultValue={userData.email}
                        isMandatory
                    />

                    <Input
                        name="salutation"
                        label={i18n.t('merge_field_salutation')}
                        placeholder={i18n.t('form.input.placeholder')}
                        onBlur={distributeStore.createUserOnChange}
                        defaultValue={userData.salutation}
                    />

                    <Input
                        name="firstname"
                        label={i18n.t('merge_field_firstname')}
                        placeholder={i18n.t('form.input.placeholder')}
                        onBlur={distributeStore.createUserOnChange}
                        defaultValue={userData.firstname}
                    />

                    <Input
                        name="lastname"
                        label={i18n.t('merge_field_lastname')}
                        placeholder={i18n.t('form.input.placeholder')}
                        onBlur={distributeStore.createUserOnChange}
                        defaultValue={userData.lastname}
                    />

                    <Input
                        name="jobtitle"
                        label={i18n.t('merge_field_jobtitle')}
                        placeholder={i18n.t('form.input.placeholder')}
                        onBlur={distributeStore.createUserOnChange}
                        defaultValue={userData.jobtitle}
                    />

                    <Input
                        name="companyname"
                        label={i18n.t('merge_field_companyname')}
                        placeholder={i18n.t('form.input.placeholder')}
                        onBlur={distributeStore.createUserOnChange}
                        defaultValue={userData.companyname}
                    />

                    <Select
                        name="surveyuserlistId"
                        label={i18n.t('createUserModal.selectList')}
                        options={distributeStore.emailListOptions}
                        onBlur={distributeStore.createUserOnListChange}
                        value={distributeStore.selectedCreateUserList}
                    />

                    {this.userLink()}

                    {this.hasPrepopulated
                        && (
                            <div>
                                <Typography type="h4">Imported Data:</Typography>

                                {prePopulatedData}
                            </div>
                        )}
                </div>

                <ModalFooter>
                    <div className="create-user-modal-buttons">
                        <Button cssClass="tertiary regular" onClick={distributeStore.hideCreateUserModal}>
                            {i18n.t('cancel')}
                        </Button>

                        <Button cssClass="primary regular" onClick={distributeStore.updateOrCreateUser}>
                            {i18n.t('save')}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreateUserModal
